import React, { useRef } from 'react';
import { ManagedImage } from '../ManagedImage';

const clamp = (n) => Math.max(0, Math.min(100, n));

// Väljare för fokuspunkt: klicka på bilden för att bestämma vad som alltid ska synas.
const FocusPicker = ({ imgProps, focusX, focusY, onChange }) => {
  const ref = useRef();
  const handleClick = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const x = clamp(Math.round(((e.clientX - rect.left) / rect.width) * 100));
    const y = clamp(Math.round(((e.clientY - rect.top) / rect.height) * 100));
    onChange(x, y);
  };
  return (
    <div className="flex flex-col gap-2">
      <p className="m-0 text-sm text-cv-muted">Klicka på den viktigaste delen av bilden så att den alltid syns i rutan:</p>
      <div
        ref={ref}
        onClick={handleClick}
        className="relative overflow-hidden border border-cv-edge"
        style={{ width: 220, height: 220, borderRadius: 'var(--cv-radius)', cursor: 'crosshair' }}
      >
        <ManagedImage {...imgProps} fit="cover" focusX={focusX} focusY={focusY} className="w-full h-full" />
        <span
          className="absolute w-5 h-5 rounded-full border-2 border-white pointer-events-none"
          style={{ left: `${focusX}%`, top: `${focusY}%`, transform: 'translate(-50%,-50%)', boxShadow: '0 0 0 2px rgba(0,0,0,0.4)' }}
        />
      </div>
      <button
        type="button"
        onClick={() => onChange(50, 50)}
        className="w-fit text-xs tracking-[0.12em] uppercase text-cv-muted border border-cv-edge rounded-cv px-3 py-1.5 hover:bg-cv-line transition-colors cursor-pointer bg-transparent"
      >
        Återställ till mitten
      </button>
    </div>
  );
};

// Kontroll för hur en bild passas in i sin ruta.
export const FitControls = ({ imgProps, value, onChange }) => {
  const { fit, focusX, focusY } = value;
  const btn = (active) =>
    `text-sm px-4 py-2 rounded-cv border cursor-pointer transition-colors ${
      active ? 'bg-cv-ink text-cv-base border-cv-ink' : 'bg-transparent text-cv-ink border-cv-edge hover:bg-cv-line'
    }`;
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1.5">
        <span className="text-sm text-cv-muted">Hur ska bilden visas i rutan?</span>
        <div className="flex gap-2 flex-wrap">
          <button type="button" onClick={() => onChange({ ...value, fit: 'cover' })} className={btn(fit === 'cover')}>
            Fyll ut rutan
          </button>
          <button type="button" onClick={() => onChange({ ...value, fit: 'contain' })} className={btn(fit === 'contain')}>
            Visa hela bilden
          </button>
        </div>
      </div>
      {fit === 'cover' ? (
        <FocusPicker imgProps={imgProps} focusX={focusX} focusY={focusY} onChange={(x, y) => onChange({ ...value, focusX: x, focusY: y })} />
      ) : (
        <p className="m-0 text-sm text-cv-muted">Hela bilden visas – inga delar beskärs bort.</p>
      )}
    </div>
  );
};
